import { Flex } from "@chakra-ui/react";
import { useParams } from "next/navigation";

import Card from "../../ui/Card";

import ListNewsItem from "./ListNewsItem";

const TopNews = ({ topNews }) => {
  const params = useParams();
  const news = topNews?.filter((item) => item?.slug !== params?.news);

  return (
    <Card cardTitle={"Top Posts"}>
      <Flex flexDir={"column"} rowGap={"20px"}>
        {news?.slice(0, 3)?.map((news) => (
          <ListNewsItem
            key={news?.id}
            {...{ item: news, customCardStyles: { w: "347px" } }}
          />
        ))}
      </Flex>
    </Card>
  );
};

export default TopNews;
